import { Link } from 'react-router-dom';
import PublicLayout from '@/components/hydlib/PublicLayout';

const mono = "'Space Mono', monospace";
const serifDisplay = "'Libre Caslon Display', serif";

export default function NotFound() {
  return (
    <PublicLayout theme="archive" grid="--a4" gridStrength={26}>
      <div className="hydlib-scallop" style={{ backgroundImage: 'radial-gradient(circle at 50% 0, var(--a4) 0 5px, transparent 6px)' }} />
      <div className="hydlib-pad" style={{ position: 'relative', maxWidth: 720, margin: '0 auto', padding: '90px 48px 110px', boxSizing: 'border-box', textAlign: 'center' }}>
        <div style={{ fontFamily: serifDisplay, fontSize: 110, lineHeight: 1, color: 'var(--a4)', marginBottom: 6 }}>404</div>
        <div style={{ fontFamily: "'Caveat', cursive", fontSize: 26, fontWeight: 600, color: 'var(--a1)', transform: 'rotate(-2deg)', marginBottom: 20 }}>this page is mis-shelved</div>
        <h1 style={{ fontFamily: serifDisplay, fontWeight: 400, fontSize: 34, margin: '0 0 12px' }} data-testid="notfound-heading">We looked everywhere.</h1>
        <p style={{ fontSize: 16, lineHeight: 1.7, opacity: 0.85, margin: '0 auto 30px', maxWidth: 460 }}>
          The page you&apos;re after isn&apos;t in our stacks — maybe it was borrowed and never returned. Try one of these instead:
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/" data-testid="notfound-home-link" style={{ border: '1px solid var(--line)', background: 'var(--ink)', color: 'var(--paper)', fontFamily: mono, fontWeight: 700, fontSize: 12, letterSpacing: 1.5, textTransform: 'uppercase', padding: '11px 22px' }}>
            ← Back home
          </Link>
          <Link to="/catalog" data-testid="notfound-catalog-link" className="hydlib-highlight" style={{ border: 'none', color: 'var(--ink)', fontFamily: mono, fontWeight: 700, fontSize: 12, letterSpacing: 1.5, textTransform: 'uppercase', padding: '11px 22px', background: `linear-gradient(104deg, transparent 1.5%, color-mix(in oklch, var(--a2) 62%, var(--paper)) 5%, color-mix(in oklch, var(--a2) 46%, var(--paper)) 52%, color-mix(in oklch, var(--a2) 68%, var(--paper)) 94%, transparent 98.5%)` }}>
            Browse the catalog →
          </Link>
        </div>
      </div>
    </PublicLayout>
  );
}
